import React, { useEffect, useState } from 'react'
import { View, Text, Image, Dimensions, ImageBackground, Platform } from 'react-native'
import styles from './RankingStyles'
import theme from '../../../theme'
import { avatarPlaceholder, placeholderGeneral } from '../customUtils/Constants'
import { FlatList, TouchableOpacity } from 'react-native-gesture-handler'
import { useIsFocused, useNavigation } from '@react-navigation/native'
import { getLanguage } from '../appBar/context/LocalizationContext'
import { RoundedTabs } from '../customUtils/LinealTabs'
import { RankingTheme } from '../../../themeConstants'
import { LinearGradient } from 'expo-linear-gradient'
import { request_get_ranking } from '../../services/ranking.services'
import { resetCache } from '../../utils/FetchServices'
import { Loader } from '../customUtils/Components/Loader'
import { getAuthToken } from '../../utils/functions.utils'
const { width, height } = Dimensions.get('window')

export const RankingScreen = () => {
    const [loading, isLoading] = useState(true)
    let isFocused: boolean = true
    try {
        isFocused = useIsFocused()
    } catch (e) {
        if (Platform?.OS === 'web') {
            isFocused = true
            if (process?.env?.NODE_ENV !== 'production') {
                console.warn('[RankingScreen] useIsFocused fallback (web sin NavigationContainer)')
            }
        } else {
            throw e
        }
    }
    useEffect(() => {
        fetchData()
    }, [isFocused])

    async function fetchData() {
        try {
            const authToken = await getAuthToken()
            if (!authToken) return
            let data = await request_get_ranking({ authToken })
            if (!data || !data.single) throw new Error('No data received from ranking service')
            const rankingData = data.single.ranking || []
            const globalRankingData = data.single.ranking_global || []
            setData({ ranking: rankingData, globalRanking: globalRankingData, history: [] })
            resetCache()
        } catch (e) {
            console.log('Error fetching ranking data: ==>', e)
        } finally {
            isLoading(false)
        }
    }
    const [data, setData] = useState({ ranking: [], globalRanking: [], history: [] })
    const { ranking, globalRanking, history } = data
    if (loading) {
        return <Loader />
    }
    return (
        <View style={styles.container}>
            <RankingTabs ranking={ranking} globalRanking={globalRanking} history={history} />
        </View>
    )
}
export const RankingTabs = ({ ranking = [], globalRanking = [], history = [] }) => {
    const [selectedIndex, setSelectedIndex] = useState(null)

    const { languageFile } = getLanguage()

    const tabs = setTabs()
    function setTabs() {
        let tabs = []
        if (ranking.length > 0) {
            tabs.push({
                name: languageFile.mensual,
                index: 0,
            })
        }
        if (globalRanking.length > 0) {
            tabs.push({
                name: languageFile.acumulado,
                index: 1,
            })
        }
        // if (history.length > 0) {
        //     tabs.push({
        //         name: 'Historial',
        //         index: 2,
        //     })
        // }
        return tabs
    }
    useEffect(() => {
        if (tabs.length === 0) {
            setSelectedIndex(-1)
        } else {
            let firstTabIndex = tabs[0].index
            setSelectedIndex(firstTabIndex)
        }
    }, [tabs.length])

    const viewMargin = tabs.length > 1 ? -15 : 0

    const findPodium = (data) => {
        let first_place = null
        let second_place = null
        let third_place = null
        if (!data || data.length === 0) return { first_place, second_place, third_place }
        first_place = data.find((item) => item.position == 1)
        second_place = data.find((item) => item.position == 2)
        third_place = data.find((item) => item.position == 3)
        return { first_place, second_place, third_place }
    }

    return (
        <View style={{ flex: 1 }}>
            {tabs.length > 1 && (
                <RoundedTabs
                    tabs={tabs}
                    selectedIndex={selectedIndex}
                    colorLGStart={RankingTheme.linearGradientStart}
                    colorLGEnd={RankingTheme.linearGradientEnd}
                    colorSelected={RankingTheme.tabsSelectedColor}
                    colorUnselected={RankingTheme.tabsUnselectedColor}
                    color={theme.colors.darkGray}
                    onSelectedTab={(index) => {
                        console.log('SELECTED INDEX', index)
                        setSelectedIndex(index)
                    }}
                />
            )}

            {(() => {
                switch (selectedIndex) {
                    case 0:
                        const { first_place, second_place, third_place } = findPodium(ranking)
                        const filteredRanking = ranking.filter((i) => Number(i.position) > 3)
                        return (
                            <View style={{ flex: 1, marginTop: viewMargin }}>
                                <RankingPodium
                                    first_place={setPodiumUser(first_place)}
                                    second_place={setPodiumUser(second_place)}
                                    third_place={setPodiumUser(third_place)}
                                />

                                <FlatList
                                    style={{ backgroundColor: 'white' }}
                                    data={filteredRanking}
                                    keyExtractor={(item, index) => index.toString()} // Usa el índice como clave
                                    horizontal={false}
                                    showsHorizontalScrollIndicator={false}
                                    showsVerticalScrollIndicator={false}
                                    renderItem={({ item }) => <RankingItem item={item} />}
                                />
                            </View>
                        )
                    case 1:
                        const {
                            first_place: globalFirstPlace,
                            second_place: globalSecondPlace,
                            third_place: globalThirdPlace,
                        } = findPodium(globalRanking)
                        const filteredGlobalRanking = globalRanking.filter((i) => Number(i.position) > 3)

                        return (
                            <View style={{ flex: 1, marginTop: viewMargin }}>
                                <RankingPodium
                                    first_place={setPodiumUser(globalFirstPlace)}
                                    second_place={setPodiumUser(globalSecondPlace)}
                                    third_place={setPodiumUser(globalThirdPlace)}
                                />
                                <FlatList
                                    style={{ backgroundColor: 'white' }}
                                    data={filteredGlobalRanking}
                                    keyExtractor={(item, index) => index.toString()} // Usa el índice como clave
                                    horizontal={false}
                                    showsHorizontalScrollIndicator={false}
                                    showsVerticalScrollIndicator={false}
                                    renderItem={({ item }) => <RankingItem item={item} />}
                                />
                            </View>
                        )
                    // case 2:
                    //     return (
                    //         <View style={{ flex: 1, backgroundColor: 'white', paddingTop: 35, paddingBottom: 5, marginTop: -10, zIndex: -1 }}>
                    //             <View style={{ zIndex: 20, flexDirection: 'row', paddingBottom: 15, paddingTop: 5, marginTop: -10 }}>
                    //                 <Text
                    //                     style={{
                    //                         flex: 2,
                    //                         fontSize: 16,
                    //                         fontWeight: 'bold',
                    //                         color: theme.colors.colorSecondary,
                    //                         marginHorizontal: 10,
                    //                     }}
                    //                 >
                    //                     Puntos
                    //                 </Text>
                    //                 <Text style={{ flex: 3, fontSize: 16, fontWeight: 'bold', marginHorizontal: -7 }}>Actividad</Text>
                    //                 <Text
                    //                     style={{
                    //                         flex: 3,
                    //                         fontSize: 16,
                    //                         fontWeight: 'bold',
                    //                         color: theme.colors.colorPrimary,
                    //                         marginRight: 15,
                    //                         textAlign: 'right',
                    //                     }}
                    //                 >
                    //                     Fecha
                    //                 </Text>
                    //             </View>
                    //             <FlatList
                    //                 data={history}
                    //                 keyExtractor={(item, index) => index.toString()} // Usa el índice como clave
                    //                 horizontal={false}
                    //                 showsHorizontalScrollIndicator={false}
                    //                 showsVerticalScrollIndicator={false}
                    //                 renderItem={({ item }) => <HistoryItem points={item.points} activity={item.type} dateString={item.date} />}
                    //             />
                    //         </View>
                    //     )
                    default:
                        return (
                            <>
                                {ranking.length === 0 && globalRanking.length === 0 && (
                                    <View style={{ flex: 1 }}>
                                        <RankingPodium
                                            first_place={setPodiumUser(null)}
                                            second_place={setPodiumUser(null)}
                                            third_place={setPodiumUser(null)}
                                        />
                                        <NoRankingModal />
                                    </View>
                                )}
                            </>
                        )
                }
            })()}
        </View>
    )
}
const RankingItem = ({ item }) => {
    const { languageFile } = getLanguage()
    const [image, setImage] = useState(item.avatar ? item.avatar : avatarPlaceholder)

    return (
        <View>
            <View style={[styles.triviaItem, { pointerEvents: 'none', paddingTop: 12, paddingBottom: 2 }]}>
                <Text style={[styles.triviaName, { marginEnd: 12, color: RankingTheme.rankingPositionTextColor, fontSize: 17, minWidth: 35 }]}>
                    {item.position + '°'}
                </Text>
                {item.avatar && (
                    <Image
                        style={styles.triviaImage}
                        source={{ uri: image }}
                        onError={() => {
                            setImage(avatarPlaceholder)
                        }}
                    />
                )}
                <View style={{ flex: 1, flexDirection: 'column', justifyContent: 'center', marginStart: 6 }}>
                    <Text
                        style={[
                            styles.triviaDescription,
                            { marginEnd: 12, color: RankingTheme.rankingUserTextColor },
                            item.current_user && { fontWeight: 'bold' },
                        ]}
                    >
                        {item.name + ' ' + (item.last_name || '')}
                    </Text>
                    {item.current_user && (
                        <Text style={{ fontWeight: '700', fontSize: 14, marginTop: 3, color: RankingTheme.podiumUserPointsTextcolor }}>
                            ¡Tu estás aquí!
                        </Text>
                    )}
                </View>
                {item.points && (
                    <View
                        style={{
                            minWidth: 100,
                            flexDirection: 'row',
                            borderWidth: 1,
                            borderColor: RankingTheme.rankingPointsBorderColor,
                            backgroundColor: 'white',
                            borderRadius: 12,
                            alignContent: 'center',
                            alignItems: 'center',
                            paddingHorizontal: 12,
                            paddingVertical: 7,
                            paddingTop: 5,
                            justifyContent: 'center',
                        }}
                    >
                        <Text style={styles.podium_user_points_text}>{item.points}</Text>
                        <Text style={styles.podium_user_points_Pts}> pts</Text>
                    </View>
                )}
            </View>
            <View style={styles.dividerHorizontalLine}></View>
        </View>
    )
}

export const HistoryItem = ({ points, activity, dateString }: { points: number; activity: string; dateString: string }) => {
    function parseFecha(dateString: string): { date: string; time: string } {
        const dateObj = new Date(dateString)
        const day = String(dateObj.getDate()).padStart(2, '0')
        const month = String(dateObj.getMonth() + 1).padStart(2, '0') // Months are zero-based
        const year = dateObj.getFullYear()
        const hours = String(dateObj.getHours()).padStart(2, '0')
        const minutes = String(dateObj.getMinutes()).padStart(2, '0')

        return {
            date: `${day}/${month}/${year}`,
            time: `${hours}:${minutes}`,
        }
    }
    const { date, time } = parseFecha(dateString)
    return (
        <View style={{ flex: 1, marginHorizontal: 3 }}>
            <View style={styles.containerItem}>
                <View style={{ flex: 2 }}>
                    <Text style={styles.position}>+{points}pts</Text>
                </View>

                <View style={{ flex: 4 }}>
                    <Text style={styles.username}>5 Reacciones en muro</Text>
                    {/* <Text style={styles.username}>{activity}</Text> */}
                </View>
                <View style={{ flex: 2 }}>
                    <Text style={[styles.points, { fontSize: 12, textAlign: 'right' }]}>{date}</Text>
                    <Text style={[styles.hr, { fontSize: 12, textAlign: 'right' }]}>{time}</Text>
                </View>
            </View>
            <View style={styles.divider3}></View>
        </View>
    )
}

export const RankingPodium = ({ first_place, second_place, third_place }) => {
    function validateImage(image) {
        if (image == undefined || image == null) return null
        if (image == '') return avatarPlaceholder
        return image
    }

    const [first_place_image, setFirstPlaceImage] = useState(validateImage(first_place.user_avatar))
    const [second_place_image, setSecondPlaceImage] = useState(validateImage(second_place.user_avatar))
    const [third_place_image, setThirdPlaceImage] = useState(validateImage(third_place.user_avatar))

    return (
        <LinearGradient
            colors={[RankingTheme.linearGradientStart, RankingTheme.linearGradientEnd]}
            style={{ width: '100%' }}
            start={{ x: 0, y: 0.5 }}
            end={{ x: 1, y: 0.5 }}
        >
            <ImageBackground
                source={require('../../../assets/ranking_podium_background.png')}
                style={{ width: width, height: 162, zIndex: 0, marginTop: 0 }}
                resizeMethod='resize'
                resizeMode='cover'
            >
                <View
                    style={{
                        flexDirection: 'row',
                        position: 'absolute',
                    }}
                >
                    <View
                        style={{
                            flex: 1,
                            paddingTop: 10,
                            top: '11%',
                            left: '7%',
                            height: 100,
                        }}
                    >
                        {second_place && (
                            <View
                                style={{
                                    position: 'absolute',
                                    zIndex: 2,
                                    alignSelf: 'center',
                                    alignContent: 'center',
                                    alignItems: 'center',
                                    width: 100,
                                }}
                            >
                                {second_place_image != null ? (
                                    <>
                                        <Image
                                            source={{ uri: second_place_image }}
                                            style={[
                                                {
                                                    zIndex: 4,
                                                    width: 60,
                                                    height: 60,
                                                    borderRadius: 30,
                                                    borderWidth: 3,
                                                    borderColor: 'white',
                                                    marginTop: -20,
                                                },
                                            ]}
                                            resizeMethod='resize'
                                            resizeMode='contain'
                                            onError={() => {
                                                setSecondPlaceImage(avatarPlaceholder)
                                            }}
                                        />
                                    </>
                                ) : (
                                    <>
                                        <Text
                                            style={{
                                                zIndex: 2,
                                                color: 'white',
                                                fontSize: 36,
                                                fontWeight: '800',
                                                width: 52,
                                                height: 52,
                                                borderRadius: 26,
                                                overflow: 'hidden',
                                                lineHeight: 48,
                                                alignSelf: 'center',
                                                backgroundColor: theme.colors.RankingSecondPlaceColor,
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                textAlign: 'center',
                                                marginTop: 3,
                                                marginRight: 3,
                                            }}
                                        >
                                            2
                                        </Text>
                                    </>
                                )}
                                {second_place.points && (
                                    <View
                                        style={[
                                            {
                                                zIndex: 4,
                                                width: 90,
                                                height: 25,
                                                borderRadius: 10,
                                                backgroundColor: 'white',
                                                marginTop: -3,
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                alignSelf: 'center',
                                                marginRight: 3,
                                                overflow: 'hidden',
                                            },
                                            second_place.current_user === true && {
                                                borderColor: theme.colors.colorSecondary,
                                                borderWidth: 2,
                                                overflow: 'hidden',
                                            },
                                        ]}
                                    >
                                        <Text
                                            style={{
                                                zIndex: 5,
                                                color: theme.colors.RankingPointsColor,
                                                fontSize: 15,
                                                fontWeight: '800',
                                                textAlign: 'center',
                                                lineHeight: 20,
                                            }}
                                        >
                                            {second_place.points}
                                            <Text style={{ color: theme.colors.RankingPointsColor, fontSize: 15, fontWeight: '400', lineHeight: 20 }}>
                                                pts
                                            </Text>
                                        </Text>
                                    </View>
                                )}
                                <Text
                                    style={{
                                        fontWeight: '500',
                                        marginVertical: 5,
                                        fontSize: 13,
                                        color: 'white',
                                        textAlign: 'center',
                                        width: 100,
                                    }}
                                    ellipsizeMode='tail'
                                    numberOfLines={1}
                                >
                                    {second_place.full_name}
                                </Text>
                            </View>
                        )}
                    </View>
                    <View style={{ flex: 1, top: '7%', height: 100 }}>
                        {first_place && (
                            <View
                                style={{
                                    alignSelf: 'center',
                                    alignContent: 'center',
                                    alignItems: 'center',
                                    width: 100,
                                }}
                            >
                                {first_place_image != null ? (
                                    <>
                                        <Text
                                            style={{
                                                zIndex: 2,
                                                color: 'white',
                                                fontSize: 36,
                                                fontWeight: '800',
                                                width: 52,
                                                height: 52,
                                                borderRadius: 26,
                                                overflow: 'hidden',
                                                lineHeight: 48,
                                                alignSelf: 'center',
                                                backgroundColor: theme.colors.RankingFirstPlaceColor,
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                textAlign: 'center',
                                                marginTop: 3,
                                                marginRight: 3,
                                            }}
                                        >
                                            1
                                        </Text>
                                        <Image
                                            source={{ uri: first_place_image }}
                                            style={[
                                                {
                                                    zIndex: 4,
                                                    width: 60,
                                                    height: 60,
                                                    borderRadius: 30,
                                                    borderWidth: 3,
                                                    borderColor: 'white',
                                                    marginTop: -20,
                                                },
                                            ]}
                                            resizeMethod='resize'
                                            resizeMode='contain'
                                            onError={() => {
                                                setFirstPlaceImage(avatarPlaceholder)
                                            }}
                                        />
                                    </>
                                ) : (
                                    <>
                                        <Text
                                            style={{
                                                zIndex: 2,
                                                color: 'white',
                                                fontSize: 36,
                                                fontWeight: '800',
                                                width: 52,
                                                height: 52,
                                                borderRadius: 26,
                                                overflow: 'hidden',
                                                lineHeight: 48,
                                                alignSelf: 'center',
                                                backgroundColor: theme.colors.RankingFirstPlaceColor,
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                textAlign: 'center',
                                                marginTop: 3,
                                                marginRight: 3,
                                            }}
                                        >
                                            1
                                        </Text>
                                    </>
                                )}
                                {first_place.points && (
                                    <View
                                        style={[
                                            {
                                                zIndex: 5,
                                                width: 90,
                                                height: 25,
                                                borderRadius: 10,
                                                backgroundColor: 'white',
                                                marginTop: -3,
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                            },
                                            first_place.current_user === true && {
                                                borderColor: theme.colors.colorSecondary,
                                                borderWidth: 2,
                                                overflow: 'hidden',
                                            },
                                        ]}
                                    >
                                        <Text
                                            style={{
                                                color: theme.colors.RankingPointsColor,
                                                fontSize: 15,
                                                fontWeight: '800',
                                                textAlign: 'center',
                                                lineHeight: 20,
                                            }}
                                        >
                                            {first_place.points}
                                            <Text style={{ color: theme.colors.RankingPointsColor, fontSize: 15, fontWeight: '400', lineHeight: 20 }}>
                                                pts
                                            </Text>
                                        </Text>
                                    </View>
                                )}
                                <Text
                                    style={{
                                        fontWeight: '500',
                                        marginVertical: 5,
                                        fontSize: 13,
                                        color: 'white',
                                        textAlign: 'center',
                                        width: 100,
                                    }}
                                    ellipsizeMode='tail'
                                    numberOfLines={3}
                                >
                                    {first_place.full_name}
                                </Text>
                            </View>
                        )}
                    </View>
                    <View style={{ flex: 1, top: '11%', right: '7%', height: 100 }}>
                        {third_place && (
                            <View style={{ alignSelf: 'center', alignContent: 'center', alignItems: 'center', width: 100 }}>
                                {third_place_image != null ? (
                                    <>
                                        <Image
                                            source={{ uri: third_place_image }}
                                            style={[
                                                {
                                                    zIndex: 2,
                                                    width: 60,
                                                    height: 60,
                                                    borderRadius: 30,
                                                    borderWidth: 3,
                                                    borderColor: 'white',
                                                    marginTop: -20,
                                                },
                                            ]}
                                            resizeMethod='resize'
                                            resizeMode='contain'
                                            onError={() => {
                                                setThirdPlaceImage(avatarPlaceholder)
                                            }}
                                        />
                                    </>
                                ) : (
                                    <>
                                        <Text
                                            style={{
                                                zIndex: 2,
                                                color: 'white',
                                                fontSize: 36,
                                                fontWeight: '800',
                                                width: 52,
                                                height: 52,
                                                borderRadius: 26,
                                                overflow: 'hidden',
                                                lineHeight: 48,
                                                alignSelf: 'center',
                                                backgroundColor: theme.colors.RankingThirdPlaceColor,
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                textAlign: 'center',
                                                marginTop: 3,
                                                marginRight: 3,
                                            }}
                                        >
                                            3
                                        </Text>
                                    </>
                                )}
                                {third_place.points && (
                                    <View
                                        style={[
                                            {
                                                zIndex: 5,
                                                width: 90,
                                                height: 25,
                                                borderRadius: 10,
                                                backgroundColor: 'white',
                                                marginTop: -3,
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                            },
                                            third_place.current_user === true && {
                                                borderColor: theme.colors.colorSecondary,
                                                borderWidth: 2,
                                                overflow: 'hidden',
                                            },
                                        ]}
                                    >
                                        <Text
                                            style={{
                                                color: theme.colors.RankingPointsColor,
                                                fontSize: 15,
                                                fontWeight: '800',
                                                textAlign: 'center',
                                                lineHeight: 20,
                                            }}
                                        >
                                            {third_place.points}
                                            <Text style={{ color: theme.colors.RankingPointsColor, fontSize: 15, fontWeight: '400', lineHeight: 20 }}>
                                                pts
                                            </Text>
                                        </Text>
                                    </View>
                                )}
                                <Text
                                    style={{
                                        fontWeight: '500',
                                        marginVertical: 5,
                                        fontSize: 13,
                                        color: 'white',
                                        textAlign: 'center',
                                        width: 100,
                                    }}
                                    ellipsizeMode='tail'
                                    numberOfLines={1}
                                >
                                    {third_place.full_name}
                                </Text>
                            </View>
                        )}
                    </View>
                </View>
            </ImageBackground>
        </LinearGradient>
    )
}
export function setPodiumUser(user) {
    const emptyRanking = { full_name: '-----', user_avatar: null, points: null, current_user: false }
    return user
        ? {
              full_name: user.name + (user.last_name ? ' ' + user.last_name : ''),
              user_avatar: user.avatar,
              points: user.points,
              current_user: user.current_user,
          }
        : emptyRanking
}

export const NoRankingModal = () => {
    return (
        <View
            style={[
                {
                    flex: 1,
                    justifyContent: 'center',
                    alignItems: 'center',
                },
                { marginHorizontal: 15 },
            ]}
        >
            <Image style={{ width: 132, height: 132 }} source={require('../../../assets/no_podium.png')} />
            <Text
                style={{
                    fontSize: 18,
                    fontWeight: 'bold',
                    color: theme.colors.textPrimary,
                    textAlign: 'center',
                    marginBottom: 8,
                    marginTop: 20,
                }}
            >
                {'El ranking se está preparando'}
            </Text>
            <Text
                style={{
                    fontSize: 15,
                    color: theme.colors.textSecondary,
                    textAlign: 'center',
                    lineHeight: 23,
                }}
            >
                {'Estamos esperando que todos elijan su alias para arrancar. ¡Pronto vas a poder ver quién lidera!'}
            </Text>
        </View>
    )
}
